import { render, staticRenderFns } from "./SamSpanLink.vue?vue&type=template&id=42fa325e&scoped=true&"
import script from "./SamSpanLink.vue?vue&type=script&lang=js&"
export * from "./SamSpanLink.vue?vue&type=script&lang=js&"
import style0 from "./SamSpanLink.vue?vue&type=style&index=0&id=42fa325e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa325e",
  null
  
)

export default component.exports